import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { NotificationApiService } from './notification-api-service';
import { BehaviorSubject } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';

export class NotificationDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<[]> = new BehaviorSubject([]);
  constructor(
    protected Api: NotificationApiService,
    private readonly role: any
  ) {
    super();
  }

  protected loadData(PageEvent: PageEvent) {
    return this.Api.get(PageEvent);
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }

  public sendNotification(notification) {
    return this.Api.send(notification);
  }
}
